(function(){
  var el = document.getElementById('cp-recs-section');
  if (!el) return;
  var pid = parseInt(el.getAttribute('data-pid'), 10);
  var sid = el.getAttribute('data-sid');
  var wrapper = el;
  var skeleton = document.getElementById('cp-recs-skeleton-' + sid);
  var grid = document.getElementById('cp-recs-results-' + sid);
  var EXCL = 'mass-readings-explained-include-trial';
  var FMTS = ['cd','mp3','dvd','blu-ray','blu ray','digital video'];

  function money(c){
    return '$' + (parseInt(c,10)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
  function lowestPrice(vv){
    return Math.min.apply(null, vv.map(function(v){ return parseInt(v.price,10); }));
  }
  function hasTag(tags, name){
    if (!tags || !tags.length) return false;
    var l = name.toLowerCase();
    return tags.some(function(t){ return t.toLowerCase() === l; });
  }
  function isBook(p){ return hasTag(p.tags,'book'); }
  function isHiddenSub(p){
    if (!hasTag(p.tags,'subscription')) return false;
    return p.handle !== EXCL;
  }
  function isPurchased(id){
    return (window.CP_purchasedProductIds || []).indexOf(id) !== -1;
  }
  function mediaVariants(vv){
    var m = vv.filter(function(v){
      var t = v.title.toLowerCase();
      return FMTS.some(function(k){ return t.indexOf(k) !== -1; });
    });
    return m.length ? m : vv;
  }
  function defaultVariant(vv){
    var mp3 = vv.filter(function(v){ return v.title.toLowerCase().indexOf('mp3') !== -1 && v.available; });
    if (mp3.length) return mp3[0];
    for (var i=0; i<vv.length; i++){ if (vv[i].available) return vv[i]; }
    return vv[0];
  }
  function filterProds(prods){
    return prods.filter(function(p){
      if (p.id === pid) return false;
      if (isBook(p)) return false;
      if (isHiddenSub(p)) return false;
      if (isPurchased(p.id)) return false;
      return true;
    }).slice(0,4);
  }
  function addToCart(vid, btn){
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.json',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:vid,quantity:1})
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      btn.textContent = 'Added \u2713';
      btn.style.background = '#cc0000';
      setTimeout(function(){
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(function(){ btn.textContent = 'Add to Cart'; btn.style.background = ''; btn.disabled = false; });
  }
  function buildCard(p){
    var mv = mediaVariants(p.variants);
    var dv = defaultVariant(mv);
    var lp = lowestPrice(mv);
    var isMp3Default = dv.title.toLowerCase().indexOf('mp3') !== -1;
    var initialPrice = isMp3Default ? 'From ' + money(lp) : money(parseInt(dv.price,10));
    var img = '';
    if (p.featured_image){
      img = p.featured_image + (p.featured_image.indexOf('?') !== -1 ? '&' : '?') + 'width=400';
    }
    var st = p.title.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    var opts = '';
    if (mv.length > 1){
      mv.forEach(function(v){
        opts += '<option value="' + v.id + '"' +
          ' data-price="' + v.price + '"' +
          ' data-is-mp3="' + (v.title.toLowerCase().indexOf('mp3') !== -1 ? '1' : '0') + '"' +
          (v.id === dv.id ? ' selected' : '') +
          (v.available ? '' : ' disabled') + '>' +
          v.title + (v.available ? '' : ' (unavailable)') + '</option>';
      });
    }
    var card = document.createElement('div');
    card.className = 'cp-recs__card';
    card.innerHTML =
      '<a class="cp-recs__img-link" href="' + p.url + '">' +
        '<div class="cp-recs__img-wrap">' +
          (img ? '<img src="' + img + '" alt="' + st + '" loading="lazy">' : '') +
        '</div></a>' +
      '<a class="cp-recs__title" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="cp-recs__price">' + initialPrice + '</div>' +
      (mv.length > 1
        ? '<div class="cp-recs__format-wrap"><select class="cp-recs__format-select">' + opts + '</select><span class="cp-recs__format-arrow" aria-hidden="true"></span></div>'

        : '') +
      '<button class="cp-recs__atc">Add to Cart</button>';
    var btn = card.querySelector('.cp-recs__atc');
    var sel = card.querySelector('.cp-recs__format-select');
    var priceEl = card.querySelector('.cp-recs__price');
    if (sel){
      sel.addEventListener('change', function(){
        var chosen = sel.options[sel.selectedIndex];
        var chosenPrice = parseInt(chosen.getAttribute('data-price'),10);
        var chosenIsMp3 = chosen.getAttribute('data-is-mp3') === '1';
        priceEl.textContent = chosenIsMp3 ? 'From ' + money(lp) : money(chosenPrice);
      });
    }
    btn.addEventListener('click', function(e){
      e.preventDefault();
      addToCart(sel ? parseInt(sel.value,10) : dv.id, btn);
    });
    return card;
  }
  function render(prods){
    window.CP_recommendedShown = window.CP_recommendedShown || [];
    if (!prods.length){ wrapper.style.display = 'none'; return; }
    prods.forEach(function(p){
      window.CP_recommendedShown.push(p.id);
      grid.appendChild(buildCard(p));
    });
    skeleton.style.display = 'none';
    grid.style.display = 'grid';
  }
  function go(){
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=12&intent=related')
    .then(function(r){ return r.json(); })
    .then(function(d){ render(filterProds(d.products || [])); })
    .catch(function(){ wrapper.style.display = 'none'; });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', go);
  } else { go(); }
})();
